import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../modules/infra/i18n';
import PieChart from './PieChart';
import PieChartLegend from './PieChartLegend';

const TopGrossingProducts = ({ data }) => (
  <div className="c-report-panel small-ml0 u-ml++ u-mt0 medium-and-down-mt++">
    <div className="c-chart-grid-left u-p0">
      <div className="c-chart-grid-left__pie-chart">
        <PieChart data={data} />
      </div>
      <div className="u-ml+">
        <div className="c-heading--small u-co-primary u-type--bold u-type--uppercase u-mb u--ml+">
          {t('reports:top_grossing_products.net_sales_by_product')}
          <div className="c-info-tooltip-new c-info-tooltip-new-handler u-type--no-transform u-ml--">
            <div className="c-info-tooltip-new__content u-type--no-transform">
              {t('reports:top_grossing_products.up_to_top_5_products')}
            </div>
          </div>
        </div>
        <PieChartLegend data={data} automationId="netSalesProduct" />
      </div>
    </div>
  </div>
);
TopGrossingProducts.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
};
TopGrossingProducts.defaultProps = {
  data: {},
};

export default TopGrossingProducts;
